var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("HeaderLanding"),
      _vm._v(" "),
      _c(
        "b-container",
        {
          staticClass: "mt-5 mb-5",
          staticStyle: { "min-height": "65vh" },
          attrs: { fluid: "" }
        },
        [
          _c(
            "b-row",
            { attrs: { "align-h": "center" } },
            [
              _c(
                "b-col",
                { attrs: { cols: "12", md: "4" } },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "event",
                              undefined,
                              $event.key,
                              undefined
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.submitForgotPassword($event)
                        }
                      }
                    },
                    [
                      _c(
                        "b-nav",
                        {
                          staticClass: "mb-5 justify-content-center nav-signin",
                          attrs: { pills: "" }
                        },
                        [
                          _c("b-nav-item", { attrs: { href: "/#/register" } }, [
                            _vm._v("Register")
                          ]),
                          _vm._v(" "),
                          _c("b-nav-item", { attrs: { active: "" } }, [
                            _vm._v("Log In")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("h4", { staticClass: "font-weight-bolder mb-4" }, [
                        _vm._v("Forgot Password")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-4 w-100",
                          attrs: { id: "input-group-1" }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "input-1",
                              state: _vm.validateState("email"),
                              type: "email",
                              placeholder: "Enter email",
                              "aria-describedby": "input-email-feedback"
                            },
                            model: {
                              value: _vm.$v.input.email.$model,
                              callback: function($$v) {
                                _vm.$set(_vm.$v.input.email, "$model", $$v)
                              },
                              expression: "$v.input.email.$model"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            {
                              staticClass: "text-left",
                              attrs: { id: "input-email-feedback" }
                            },
                            [
                              _vm._v(
                                "This is a required field and must be a valid email."
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "btn-block",
                          attrs: { type: "submit", variant: "primary" }
                        },
                        [_vm._v("Submit")]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "border-bottom border-dark mb-3",
                        staticStyle: { "margin-top": "89px" }
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-center" }, [
                        _vm._v(
                          "Download MusicVerse. Your one-stop app for sacred music"
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        {
                          staticClass:
                            "justify-content-center align-items-center flex-column flex-sm-row"
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "mt-3 mt-sm-0 mr-0 mr-sm-3 content-logo",
                              attrs: {
                                href: _vm.appStoreUrl,
                                "aria-label": "App Store",
                                target: "_blank",
                                rel: "noopener noreferrer"
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "content-logo",
                                attrs: {
                                  src: require("@/assets/applestore-logo.png"),
                                  alt: "App Store"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "mt-3 mt-sm-0 mr-0 mr-sm-3 content-logo",
                              attrs: {
                                href: _vm.googlePlayUrl,
                                "aria-label": "Google Play",
                                target: "_blank",
                                rel: "noopener noreferrer"
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "content-logo",
                                attrs: {
                                  src: require("@/assets/googleplay-logo.png"),
                                  alt: "Google Play"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "mt-3 mt-xl-0 content-logo radius",
                              attrs: {
                                href: _vm.appGalleryUrl,
                                "aria-label": "App Gallery",
                                target: "_blank",
                                rel: "noopener noreferrer"
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "content-logo radius",
                                attrs: {
                                  src: require("@/assets/huawei-logo.png"),
                                  alt: "App Gallery"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("FooterLanding")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01266098", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01266098","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ForgotPassword.vue
// module id = null
// module chunks = 